// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UgtQ","title":"Header_title__3k-Vw","side":"Header_side__1UGUB"};